import styled from 'styled-components';

interface ToastContainerProps {
  $isAr: boolean;
  $minWidth: string;
}

interface ToastContentProps {
  $isAr: boolean;
}

export const ToastContainer = styled.div<ToastContainerProps>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  border-radius: 20px;
  padding: 12px 16px;
  width: fit-content;
  min-width: ${props => props.$minWidth};
  max-width: 700px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  direction: ${props => props.$isAr ? 'rtl' : 'ltr'};
  position: relative;
`;

export const ToastContent = styled.div<ToastContentProps>`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 12px;
`;

export const ToastMessage = styled.div`
  font-weight: 400;
  color: #000000;
  font-size: 16px;
  line-height: 24px;
  font-family: 'Tajawal', sans-serif;
`;

export const ToastCloseButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4px;
  
  &:hover {
    opacity: 0.8;
  }
`;

export const ToastIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
`;

export const SnackbarContainer = styled.div`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  pointer-events: none;
  
  & > * {
    pointer-events: auto;
  }
`;

export const SnackbarWrapper = styled.div<{ $isVisible: boolean }>`
  transition: all 0.3s ease-in-out;
  opacity: ${props => props.$isVisible ? 1 : 0};
  transform: translateY(${props => props.$isVisible ? '0' : '20px'});
`;

// Warning Alert Components
export const WarningAlert = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 8px;
  padding: 12px 16px;
  color: #856404;
  font-size: 14px;
  width: 400px;
  max-width: 80%;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  font-family: 'Tajawal', sans-serif;
`;

export const WarningCloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #856404;
  font-size: 18px;
  padding: 0;
  margin-left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    opacity: 0.7;
  }
`;

// Icon styling for SVG components
export const IconSvg = styled.div`
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 100%;
    height: 100%;
  }
`;
